import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

export const useUserClients = () => {
  const { user } = useAuth();

  const userClients = useMemo(() => {
    if (!user) return [];

    // Get user's assigned clients from account_access
    return (
      user.account_access?.map((access) => ({
        accountUid: access.account_uid,
        canRead: access.can_read,
        canWrite: access.can_write,
        canDelete: access.can_delete,
      })) || []
    );
  }, [user]);

  const hasClientAccess = (accountUid: string): boolean => {
    return userClients.some((client) => client.accountUid === accountUid);
  };

  const getClientPermissions = (accountUid: string) => {
    const client = userClients.find((c) => c.accountUid === accountUid);
    return client
      ? {
          canRead: client.canRead,
          canWrite: client.canWrite,
          canDelete: client.canDelete,
        }
      : null;
  };

  return {
    userClients,
    hasClientAccess,
    getClientPermissions,
  };
};
